import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaUser, FaLock } from "react-icons/fa";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";

const AdminLogin = () => {
  const [data, setData] = useState({
    username: "",
    password: "",
  });

  const [open, setOpen] = useState(false);

  const navigate = useNavigate();

  const handleLogin = () => {
    if (
      data.username.trim() === "" ||
      data.password.trim() === ""
    ) {
      alert("Please enter Username and Password");
      return;
    }

    fetch("https://deoria.ilakshyaerp.in/api/admin/login", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((res) => {
        if (!res.ok) throw new Error();
        return res.json();
      })
      .then((res) => {
        localStorage.setItem(
          "adminToken",
          res.token
        );

        navigate("/admin/dashboard");
      })
      .catch(() =>
        alert("Invalid credentials")
      );
  };

  return (
    <>
      <Header
        toggleSidebar={() =>
          setOpen(true)
        }
      />

      <Sidebar
        isOpen={open}
        close={() =>
          setOpen(false)
        }
      />

      {/* LOGIN PAGE */}
      <div
        style={{
          background:
            "linear-gradient(135deg,#edf4f8,#d9e6ef)",
          minHeight: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: "40px 20px",
        }}
      >
        <div
          style={{
            width: "100%",
            maxWidth: "450px",
            background: "#fff",
            borderRadius: "25px",
            overflow: "hidden",
            boxShadow:
              "0 15px 40px rgba(0,0,0,0.15)",
          }}
        >

          {/* TOP SECTION */}
          <div
            style={{
              background:
                "linear-gradient(90deg,#003b00,#006400)",
              padding: "40px 30px",
              textAlign: "center",
            }}
          >

            <h2
              style={{
                color: "#fff",
                fontSize: "34px",
                fontWeight: "700",
                marginBottom: "10px",
              }}
            >
              Admin Login
            </h2>

            <p
              style={{
                color: "#d6f5d6",
                letterSpacing: "1px",
                fontSize: "14px",
              }}
            >
              NAV JEEVAN MISSION SCHOOL
            </p>

          </div>

          {/* FORM */}
          <div style={{ padding: "40px 30px" }}>

            {/* USERNAME */}
            <div style={{ marginBottom: "25px" }}>

              <label
                style={{
                  display: "block",
                  marginBottom: "10px",
                  fontWeight: "600",
                  color: "#003b00",
                }}
              >
                Username
              </label>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  background: "#f4f7f9",
                  border: "1px solid #ddd",
                  borderRadius: "14px",
                  padding: "14px 18px",
                }}
              >

                <FaUser
                  style={{
                    color: "#006400",
                    marginRight: "12px",
                  }}
                />

                <input
                  type="text"
                  placeholder="Enter Username"
                  value={data.username}
                  onChange={(e) =>
                    setData({
                      ...data,
                      username: e.target.value,
                    })
                  }
                  style={{
                    border: "none",
                    outline: "none",
                    background: "transparent",
                    width: "100%",
                    fontSize: "15px",
                  }}
                />

              </div>

            </div>

            {/* PASSWORD */}
            <div style={{ marginBottom: "30px" }}>

              <label
                style={{
                  display: "block",
                  marginBottom: "10px",
                  fontWeight: "600",
                  color: "#003b00",
                }}
              >
                Password
              </label>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  background: "#f4f7f9",
                  border: "1px solid #ddd",
                  borderRadius: "14px",
                  padding: "14px 18px",
                }}
              >

                <FaLock
                  style={{
                    color: "#006400",
                    marginRight: "12px",
                  }}
                />

                <input
                  type="password"
                  placeholder="Enter Password"
                  value={data.password}
                  onChange={(e) =>
                    setData({
                      ...data,
                      password: e.target.value,
                    })
                  }
                  style={{
                    border: "none",
                    outline: "none",
                    background: "transparent",
                    width: "100%",
                    fontSize: "15px",
                  }}
                />

              </div>

            </div>

            {/* BUTTON */}
            <button
              onClick={handleLogin}
              style={{
                width: "100%",
                background:
                  "linear-gradient(90deg,#003b00,#006400)",
                color: "#fff",
                border: "none",
                padding: "16px",
                borderRadius: "14px",
                fontWeight: "700",
                letterSpacing: "2px",
                fontSize: "15px",
                cursor: "pointer",
                transition: "0.3s",
              }}
            >
              LOGIN
            </button>

          </div>

        </div>
      </div>

      <Footer />
    </>
  );
};

export default AdminLogin;